import commonPostTypeConfig from '../../common/postTypes/order'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'order',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
